import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { BetterStandard } from "@/components/site/BetterStandard";
import { MobilityServices } from "@/components/site/MobilityServices";
import { Marquee } from "@/components/site/Marquee";
import { WhyBettr } from "@/components/site/WhyBettr";
import { JourneyTypes } from "@/components/site/JourneyTypes";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    // Anchor links -> smooth scroll via Lenis
    const onClick = (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute("href");
      if (id.length <= 1) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: id === "#top" ? 0 : -72 });
      }
    };
    document.addEventListener("click", onClick);

    // Deep-link: jump to hash target on load
    if (window.location.hash && window.location.hash.length > 1) {
      const target = document.querySelector(window.location.hash);
      if (target) {
        setTimeout(() => lenis.scrollTo(target, { offset: -72, immediate: true }), 400);
      }
    }

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-dark">
      <Navbar />
      <main>
        <Hero />
        <BetterStandard />
        <MobilityServices />
        <Marquee />
        <WhyBettr />
        <JourneyTypes />
      </main>
      <Footer />
    </div>
  );
}

export default App;
